import PropTypes from 'prop-types';
import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/lib/Button';
import Grid from 'react-bootstrap/lib/Grid';

import styles from './PricingNeedToHire.module.scss';

export default class PricingNeedToHire extends Component {
  static propTypes = {
    className: PropTypes.string,
    gradient: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.oneOf(['left', 'right']),
    ]),
    usersCount: PropTypes.string,
  };

  static defaultProps = {
    gradient: false,
    usersCount: '0',
  };

  constructor() {
    super();

    this.state = {
      visible: false,
    };
  }

  render() {
    const { className, gradient, usersCount, ...rest } = this.props;

    const { visible } = this.state;

    return (
      <VisibilitySensor
        partialVisibility
        delayedCall
        minTopValue={visible ? 0 : 100}
        active={!visible}
        onChange={(isVisible) => this.setState({ visible: isVisible })}
      >
        <div
          className={
            (gradient
              ? styles.gradient +
                ' ' +
                (gradient === 'left'
                  ? styles.gradientLeft
                  : styles.gradientRight)
              : styles.noGradient) + (className ? ' ' + className : '')
          }
          {...rest}
        >
          <div className={styles.container}>
            <Grid>
              <h3 className={styles.title + (visible ? '' : ' ' + styles.hide)}>
                Do you need to hire a creative?
              </h3>
              <p
                className={
                  styles.description + (visible ? '' : ' ' + styles.hide)
                }
              >
                With over {usersCount} creative freelancers on Twine, you can
                expand your business quickly
              </p>
              <div
                className={
                  styles.buttonContainer + (visible ? '' : ' ' + styles.hide)
                }
              >
                <Link to="/pricing">
                  <Button bsStyle="success" className={styles.button}>
                    More about Pricing
                  </Button>
                </Link>
              </div>
            </Grid>
          </div>
        </div>
      </VisibilitySensor>
    );
  }
}
